var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13763_618769",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 5,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 5,
    rx: 1,
    stroke: "#F4955F",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_13763_618769)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_13763_618769",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 13,
    height: 5,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 13,
    height: 5,
    rx: 1,
    stroke: "#F4955F",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2_13763_618769)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_13763_618769",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 12,
    height: 5,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 12,
    height: 5,
    rx: 1,
    stroke: "#F4955F",
    strokeWidth: 3,
    mask: "url(#path-3-inside-3_13763_618769)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00029 16C7.00029 15.3905 7.00023 14.3979 7.00016 13.4998C7.00008 12.3952 7.89558 11.5 9.0002 11.5C9.36771 11.5 9.72235 11.5 10 11.5",
    stroke: "#F4955F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C17.9999 9.71182 17.9999 8.56981 17.9999 7.50846C18 6.40054 17.0988 5.50801 15.9909 5.50392C15.6528 5.50267 15.5107 5.5 15 5.5",
    stroke: "#F4955F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow1);
export default __webpack_public_path__ + "static/media/flow-1.7f955cb723a19b431a69cf610fa98e34.svg";
export { ForwardRef as ReactComponent };